const normalizeDailySegmentLimit = (value: string): string => value.trim().replace(/,/g, '')

const parseDailySegmentLimit = (value: string): number | null => {
  const normalized = normalizeDailySegmentLimit(value)
  if (!normalized) return 0
  const parsed = Number(normalized)
  return Number.isInteger(parsed) && parsed >= 0 ? parsed : null
}

export const isValidDailySegmentLimitInput = (value: string): boolean => parseDailySegmentLimit(value) != null

export const toDailySegmentLimitPatch = (value: string): number => parseDailySegmentLimit(value) ?? 0

export const toDailySegmentLimitInput = (value: string): string => {
  const parsed = parseDailySegmentLimit(value)
  return parsed == null ? value : String(parsed)
}

export const toDailySegmentLimitDisplay = (value: unknown): string => {
  if (typeof value === 'number' && Number.isInteger(value) && value >= 0) return String(value)
  return '0'
}
